// Libraries
import { Pipe, PipeTransform } from '@angular/core';

// Models
import { OBJECT_TYPES } from './../models/object-type.interface';

/**
 * `ObjectTypePipe` returns the type name of current object.
 */
@Pipe({name: 'sheObjectType'})
export class ObjectTypePipe implements PipeTransform {
  /**
   * Return value OBJECT_TYPES.
   */
  transform(value: number): string {
    return OBJECT_TYPES[value - 1];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/pipes/object-type.pipe.ts